import React from 'react';
import SectionTitle from '../../components/SectionTitles/SectionTitle';
import HomeCardData from '../../data/work/HomeCardData.json';
// import WorkItemTwo from '../../components/Work/WorkItemTwo.jsx';
import WorkItemTwoCard from '../../components/Work/WorkItemTwoCard';

const HomeCards = () => {
    return (
        <div className="section  section section-paddingTopBottom " style={{backgroundColor:''}}>
            <div className="container" >

                <SectionTitle
                    headingOption="title fz-32"
                    title="How It Works"
                />

                <div className="row row-cols-lg-3 row-cols-md-2 row-cols-1 mb-n6 content-paddingTop" style={{paddingBottom:'20px'}} >

                    {HomeCardData && HomeCardData.map((single, key) => {
                            return(
                                <div key={key} className="col mb-6" data-aos="fade-up" data-aos-delay="300" >
                                    <WorkItemTwoCard classOption="box-border" data={single} key={key} />
                                </div>
                            ); 
                    })}
                    
                </div>

            </div>
        </div>
    )
}

export default HomeCards;
